import { i18n } from '@/i18n'
import cookie from "@/assets/js/cookie";
// import * as Sentry from '@sentry/browser';
// 全局常量
const constants = {
  // 用户权限列表
  roleList: {
    0: {
      name: i18n.t('role.plantOwner'),
      group: 'general'
    },
    1: {
      name: i18n.t('role.manufacturer'),
      group: 'admin'
    },
    2: {
      name: i18n.t('role.distributor'),
      group: 'admin'
    },
    3: {
      name: i18n.t('role.group'),
      group: 'admin'
    },
    5: {
      name: i18n.t('role.viewer'),
      group: 'general'
    },
    15: {
      name: i18n.t('account.admin'),
      group: 'admin'
    },
  },
  // 用户权限列表新版
  roleListNew: {
    // 普通用户
    0: {
      name: i18n.t('role.plantOwnerNew'),
      group: 'general'
    },
    // 制造商
    1: {
      name: i18n.t('role.manufacturer'),
      group: 'admin'
    },
    // 经销商
    2: {
      name: i18n.t('role.distributor'),
      group: 'admin'
    },
    // group
    3: {
      name: i18n.t('role.group'),
      group: 'admin'
    },
    // viewer
    5: {
      name: i18n.t('role.viewer'),
      group: 'general'
    },
    15: {
      name: i18n.t('account.admin'),
      group: 'admin'
    },
  },
  // 设备状态表
  deviceStatus: {
    0: {
      label: i18n.t('statistic.normal'),
      class: 'status-normal',
      name: 'normal'
    },
    1: {
      label: i18n.t('statistic.offline'),
      class: 'status-offline',
      name: 'offline'
    },
    2: {
      label: i18n.t('statistic.fault'),
      class: 'status-fault',
      name: 'fault'
    },
    3: {
      label: i18n.t('statistic.standby'),
      class: 'status-standby',
      name: 'standby'
    },
    4: {
      label: i18n.t('statistic.warning'),
      class: 'status-warning',
      name: 'warning'
    }
  },
  // 设备状态表带所有
  deviceStatusAll: {
    0: {
      label: i18n.t('statistic.All'),
      // class: 'status-normal',
      name: 'all'
    },
    1: {
      label: i18n.t('statistic.normal'),
      class: 'status-normal',
      name: 'normal'
    },
    2: {
      label: i18n.t('statistic.offline'),
      class: 'status-offline',
      name: 'offline'
    },
    3: {
      label: i18n.t('statistic.fault'),
      class: 'status-fault',
      name: 'fault'
    },
    4: {
      label: i18n.t('statistic.standby'),
      class: 'status-standby',
      name: 'standby'
    },
    5: {
      label: i18n.t('statistic.warning'),
      class: 'status-warning',
      name: 'warning'
    }
  },
  // 设备状态表带阴影
  deviceStatusShadow: {
    0: {
      label: i18n.t('statistic.normal'),
      class: 'status-normal-shadow',
      name: 'normal'
    },
    1: {
      label: i18n.t('statistic.offline'),
      class: 'status-offline-shadow',
      name: 'offline'
    },
    2: {
      label: i18n.t('statistic.fault'),
      class: 'status-fault-shadow',
      name: 'fault'
    },
    3: {
      label: i18n.t('statistic.standby'),
      class: 'status-standby-shadow',
      name: 'standby'
    },
    4: {
      label: i18n.t('statistic.warning'),
      class: 'status-warning-shadow',
      name: 'warning'
    }
  },
  // 设备类型
  deviceType: {
    0: {
      value: "0",
      label: i18n.t('device.brand0')
    },
    1: {
      value: "1",
      label: i18n.t('device.brand1')
    },
    2: {
      value: "2",
      label: i18n.t('device.brand2')
    },
    3: {
      value: "3",
      label: i18n.t('device.brand3')
    },
  },
  // 各国中心坐标
  countryPosition: [
    {
      zh_CN: '中国',
      en_US: 'China',
      position: [104.20, 35.86]
    },
    {
      zh_CN: '美国',
      en_US: 'United States',
      position: [-95.71, 37.09]
    },
    {
      zh_CN: '巴西',
      en_US: 'Brazil',
      position: [-51.93, -14.24]
    },
    {
      zh_CN: '澳大利亚',
      en_US: 'Australia',
      position: [133.78, -25.27]
    },
    {
      zh_CN: '俄罗斯',
      en_US: 'Russia',
      position: [105.32, 61.52]
    },
    {
      zh_CN: '智利',
      en_US: 'Chile',
      position: [-71.54, -35.68]
    },
    {
      zh_CN: '印度',
      en_US: 'India',
      position: [78.96, 20.59]
    },
    {
      zh_CN: '新加坡',
      en_US: 'Singapore',
      position: [103.82, 1.35]
    },
    {
      zh_CN: '罗马尼亚',
      en_US: 'Romania',
      position: [24.97, 45.94]
    },
    {
      zh_CN: '法国',
      en_US: 'France',
      position: [2.21, 46.23]
    },
    {
      zh_CN: '尼日尼亚',
      en_US: 'Nigeria',
      position: [8.68, 9.08]
    },
    {
      zh_CN: '加拿大',
      en_US: 'Canada',
      position: [-106.35, 56.13]
    },
    {
      zh_CN: '印度尼西亚',
      en_US: 'Indonesia',
      position: [113.92, -0.79]
    },
    {
      zh_CN: '泰国',
      en_US: 'Thailand',
      position: [100.99, 15.87]
    },
  ],
  // 时区
  timezone: {
    '-43200': {
      name: 'GMT -12:00',
      label: i18n.t('constant.gmt_neg_12'),
    },
    '-39600': {
      name: 'GMT -11:00',
      label: i18n.t('constant.gmt_neg_11'),
    },
    '-36000': {
      name: 'GMT -10:00',
      label: i18n.t('constant.gmt_neg_10'),
    },
    '-32400': {
      name: 'GMT -09:00',
      label: i18n.t('constant.gmt_neg_9'),
    },
    '-28800': {
      name: 'GMT -08:00',
      label: i18n.t('constant.gmt_neg_8'),
    },
    '-25200': {
      name: 'GMT -07:00',
      label: i18n.t('constant.gmt_neg_7'),
    },
    '-21600': {
      name: 'GMT -06:00',
      label: i18n.t('constant.gmt_neg_6'),
    },
    '-18000': {
      name: 'GMT -05:00',
      label: i18n.t('constant.gmt_neg_5'),
    },
    '-14400': {
      name: 'GMT -04:00',
      label: i18n.t('constant.gmt_neg_4'),
    },
    '-10800': {
      name: 'GMT -03:00',
      label: i18n.t('constant.gmt_neg_3'),
    },
    '-7200': {
      name: 'GMT -02:00',
      label: i18n.t('constant.gmt_neg_2'),
    },
    '-3600': {
      name: 'GMT -01:00',
      label: i18n.t('constant.gmt_neg_1'),
    },
    '0': {
      name: 'GMT +00:00',
      label: i18n.t('constant.gmt0'),
    },
    '3600': {
      name: 'GMT +01:00',
      label: i18n.t('constant.gmt_1'),
    },
    '7200': {
      name: 'GMT +02:00',
      label: i18n.t('constant.gmt_2'),
    },
    '10800': {
      name: 'GMT +03:00',
      label: i18n.t('constant.gmt_3'),
    },
    '14400': {
      name: 'GMT +04:00',
      label: i18n.t('constant.gmt_4'),
    },
    '18000': {
      name: 'GMT +05:00',
      label: i18n.t('constant.gmt_5'),
    },
    '19800': {
      name: 'GMT +05:30',
      label: i18n.t('constant.gmt_55'),
    },
    '21600': {
      name: 'GMT +06:00',
      label: i18n.t('constant.gmt_6'),
    },
    '23400': {
      name: 'GMT +06:30',
      label: i18n.t('constant.gmt_65'),
    },
    '25200': {
      name: 'GMT +07:00',
      label: i18n.t('constant.gmt_7'),
    },
    '28800': {
      name: 'GMT +08:00',
      label: i18n.t('constant.gmt_8'),
    },
    '32400': {
      name: 'GMT +09:00',
      label: i18n.t('constant.gmt_9'),
    },
    '36000': {
      name: 'GMT +10:00',
      label: i18n.t('constant.gmt_10'),
    },
    '39600': {
      name: 'GMT +11:00',
      label: i18n.t('constant.gmt_11'),
    },
    '43200': {
      name: 'GMT +12:00',
      label: i18n.t('constant.gmt_12'),
    },
  },
  // 货币
  currency: [
    { currency: "￥", label: i18n.t('constant.renminbi') },
    { currency: "$", label: i18n.t('constant.meiyuan') },
    { currency: "€", label: i18n.t('constant.ouyuan') },
    { currency: "$A", label: i18n.t('constant.aoyuan') },
    { currency: "£", label: i18n.t('constant.yingbang') },
    { currency: "HK$", label: i18n.t('constant.gangbi') },
    { currency: "Kr", label: i18n.t('constant.ruidian') },
    { currency: "₹", label: i18n.t('constant.lubi') },
    { currency: "Mex$", label: i18n.t('constant.moxige') },
    { currency: "R$", label: i18n.t('constant.baxi') },
    { currency: "Rs", label: i18n.t('constant.Pakistani') },
    { currency: "R", label: i18n.t('constant.Rand') }
  ],
  // 皮肤配置项
  skin: {
    blue: {
      variable: {
        '--siderbar-color': '#222a37', // 侧边栏色
        '--theme-color': '#1890ff',    // 主题色
        '--hover-color': '#40a9ff',   // 悬浮色
        '--active-color': '#096dd9', // 点击色
        '--bg-start-color': '#2f54eb',// 渐变起始色
        '--bg-end-color': '#1890ff' // 渐变终止色
      },
      name: i18n.t('customize.blue')
    },
    classic: {
      variable: {
        '--siderbar-color': '#222a37', // 主题色
        '--theme-color': '#FD8F76', // 主题色
        '--hover-color': '#faaf9e', // 悬浮色
        '--active-color': '#faaf9e', // 悬浮色
        '--bg-start-color': '#fb7e7f', // 渐变起始色
        '--bg-end-color': '#ff9e6e' // 渐变终止色
      },
      name: i18n.t('customize.classic')
    },
    purple: {
      variable: {
        '--siderbar-color': '#222a37', // 侧边栏色
        '--theme-color': '#a16de8',
        '--hover-color': '#ba8cfa',
        '--active-color': '#ba8cfa',
        '--bg-start-color': '#8665dd',
        '--bg-end-color': '#c776f6'
      },
      name: i18n.t('customize.purple')
    },
    orange: {
      variable: {
        '--siderbar-color': '#222a37', // 侧边栏色
        '--theme-color': '#ffb000',
        '--hover-color': '#faca7d',
        '--active-color': '#faca7d',
        '--bg-start-color': '#ff9b00',
        '--bg-end-color': '#ffc800'
      },
      name: i18n.t('customize.orange')
    },
    green: {
      variable: {
        '--siderbar-color': '#222a37', // 侧边栏色
        '--theme-color': '#78c145',
        '--hover-color': '#73e739',
        '--active-color': '#73e739',
        '--bg-start-color': '#5daf33',
        '--bg-end-color': '#9eda5d'
      },
      name: i18n.t('customize.green')
    }
  }
}
export default {
  ...constants,

  // Sentry未使用
  // //sentry 捕获操作信息 埋点上报
  // //mes 记录操作内容：登录、登出...
  // captureMessage(mes,exMes){
  //   let userName = JSON.parse(cookie.getCookie('usr'))
  //   const dayjs = require("dayjs");
  //   let nowTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
  //   let message
  //   if(mes){
  //     message ='用户' + userName + '__' + nowTime + '__' + mes + '(。・ω・。)'
  //   }else{
  //     if(exMes.toPath === "/entry"){
  //       exMes.toTitle = '登录'
  //     }  
  //     if(exMes.fromPath === "/entry"){
  //       exMes.fromTitle = '登录'
  //     }  
  //     if(exMes.toPath === '/home'){
  //       exMes.toTitle = '总览'
  //     }  
  //     if(exMes.fromTitle == undefined || exMes.fromPath ==='/'){
  //       return
  //     }
  //     if(exMes.toTitle == undefined || exMes.toPath ==='/'){
  //       return
  //     }
  //     message ='用户' + userName + '离开了' + exMes.fromTitle + '页面' + '⨠⨠⨠' + '进入了' + exMes.toTitle + '页面'+ '__' + nowTime
  //   }
  //   Sentry.setExtra('EXTRA_INFO',exMes);
  //   Sentry.captureMessage(message);
  // },

  // 格式化数字
  formatNum(num, precision = 0, type) {
    num = num || 0
    switch (type) {
      //万化,超过4位以W结尾
      case "W":
        if ((num + "").length <= 4) return num;
        return ((num - 0) / 10000).toFixed(precision) + "W";
      //化为千分位形式
      case ",":
        if ((num + "").length <= 3) return num;
        num = num + "";
        if (!num.includes(".")) {
          num += ".";
        }
        return num
          .replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
            return $1 + ",";
          })
          .replace(/\.$/, '')
      // 正整数补零
      case 'pad':
        return (new Array(precision).fill('0').join('') + num).slice(-precision)
      default:
        return (num - 0).toFixed(precision);
    }
  },

  // 格式化日期
  formatDate(date, format = 'yyyy-MM-dd hh:mm:ss') {
    if (typeof date == 'string') {
      date = new Date(date.replace(/-/g, "/"))
    }
    let obj = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      "S+": date.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (let k in obj) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ?
          obj[k] : ("00" + obj[k]).substr(("" + obj[k]).length));
      }
    }
    return format;
  },
  // 格式化日期，火狐浏览器针对yyyy-MM或yyyy格式不识别
  formatDate1(date, format = 'yyyy-MM-dd hh:mm:ss') {
    date = new Date(date)
    let obj = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      "S+": date.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (let k in obj) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ?
          obj[k] : ("00" + obj[k]).substr(("" + obj[k]).length));
      }
    }
    return format;
  },
    formatDateSafe(date, format = 'yyyy-MM-dd hh:mm:ss') {
    // 1. 纯年份
    if (typeof date === 'string' && /^\d{4}$/.test(date)) {
      if (format === 'yyyy') return date;
      // 其它格式可扩展
    }
    // 2. 年月
    if (typeof date === 'string' && /^\d{4}-\d{2}$/.test(date)) {
      const [y, m] = date.split('-');
      if (format === 'yyyy') return y;
      if (format === 'MM') return m;
      if (format === 'yyyy-MM') return `${y}-${m}`;
      // 其它格式可扩展
    }
    // 3. 年月日
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      const [y, m, d] = date.split('-');
      if (format === 'yyyy') return y;
      if (format === 'MM') return m;
      if (format === 'dd') return d;
      if (format === 'yyyy-MM-dd') return `${y}-${m}-${d}`;
      // 其它格式可扩展
    }
    // 4. 其它情况 fallback 到 formatDate1
    return this.formatDate1(date, format);
  },
  // 生成随机数 --digit：位数
  randomNum(digit = 1) {
    let random = Math.floor(Math.random() * Math.pow(10, digit));
    return (new Array(digit).fill(0).join() + random).slice(-digit);
  },

  // 首字母大写
  capitalFirstLetter(s) {
    return s.toLowerCase().replace(/\b([\w|']+)\b/g, function (word) {
      return word.replace(word.charAt(0), word.charAt(0).toUpperCase());
    });
  },
  // 判断用户权限
  role(val) {
    return constants.roleList[val] || constants.roleList[0]
  },
  // 判断用户权限新版
  roleNew(val) {
    return constants.roleListNew[val] || constants.roleListNew[0]
  },
  // 翻译设备类型
  translateDeviceType(id) {
    return constants.deviceType[id] ? constants.deviceType[id].label : ''
  }
}